import { snakeCase } from 'change-case'

import { isRecord } from '../../utils/type/isRecord'

const isPrimitive = (value: unknown): value is number | string | boolean => {
  return ['number', 'string', 'boolean'].includes(typeof value)
}

export const toExtraFields = (
  record: Record<string, unknown>
): Record<string, string> => {
  const flattened: Record<string, string> = {}

  const visited = new Map<unknown, string[]>()

  const setDataOnPath = (data: unknown, path: string[] = []) => {
    if (isPrimitive(data)) {
      flattened[path.join('.')] = data.toString()
    }

    if (data === null) {
      flattened[path.join('.')] = 'null'
    }

    if (isRecord(data)) {
      if (visited.has(data)) {
        flattened[path.join('.')] = `[Ref ${visited.get(data)?.join('.')}]`

        return
      }

      visited.set(data, ['#', ...path])

      for (const [key, value] of Object.entries(data)) {
        setDataOnPath(value, [...path, snakeCase(key)])
      }
    }

    // eslint-disable-next-line vtex/prefer-early-return
    if (Array.isArray(data)) {
      if (visited.has(data)) {
        flattened[path.join('.')] = `[Ref ${visited.get(data)?.join('.')}]`

        return
      }

      visited.set(data, ['#', ...path])

      data.forEach((item, index) => {
        setDataOnPath(item, [...path, index.toString()])
      })
    }
  }

  setDataOnPath(record)

  return flattened
}
